export default "__VITE_ASSET__B3Vo9Ig2__"